import { InputAdornment, TextField } from '@mui/material';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { Search } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import {
  ArrowUpDownIcon, ShuffleIcon,
} from '../../../../assets/TableIcons';
import { UnitData, UpdateExcelPayloadAction } from '../../utils/types';
import { RootState } from '../../../../redux/rootState';
import { getAllUnitSerialNumberStart, setUnitData, updateExcelDataUnit } from '../../redux/oilReportSlice';
import { GetListingPayload } from '../../../../utils/type';
import NoData from '../../../../assets/NoData.svg';
import { ModalPaginationWithoutPageSize } from '../pagination/paginationWithoutPageSize';
import { defaultPageSize } from '../../../../utils/Constant';

export function ReplaceUnit() {
  const {
    selectedUnitSerialNumber,
    allUnitSerialNumbers, excelData, totalUnitSerialNumbers,
  } = useSelector((state:RootState) => state.oilReportReducer);
  const dispatch = useDispatch();

  const [unitPage, setUnitPage] = useState(1);
  const [unitRowsPerPage, setUnitRowsPerPage] = useState(defaultPageSize);
  const [unitSearchQuery, setUnitSearchQuery] = useState('');
  const [sortCol, setSortCol] = useState('');
  const [sortDir, setSortDir] = useState('asc');

  const handleUnitData = () => {
    const payload:GetListingPayload = {
      page: unitPage,
      rowsPerPage: unitRowsPerPage,
      searchQuery: unitSearchQuery,
      sortCol,
      sortDir,
    };
    dispatch(getAllUnitSerialNumberStart(payload));
  };
  useEffect(() => {
    handleUnitData();
  }, [sortCol, sortDir]);

  // eslint-disable-next-line max-len
  // const selectedUnit:string = useMemo(() => excelData.find((data) => data.ReportId === selectedUnitSerialNumber)?.UnitSerialNumber || '', [selectedUnitSerialNumber]);

  const handleReplaceUnit = (value: string) => {
    const ReplacedValue = excelData.find((data) => data.ReportId === selectedUnitSerialNumber)?.UnitSerialNumber || '';
    const obj:UnitData = {
      ReportId: selectedUnitSerialNumber,
      Value: value,
      ReplacedValue,
    };

    const updateExcelPayload:UpdateExcelPayloadAction = {
      unitSerialNumber: value,
      isReplaced: true,
    };

    dispatch(setUnitData(obj));
    dispatch(updateExcelDataUnit(updateExcelPayload));
  };

  const handleSearchChange = (event:ChangeEvent<HTMLInputElement>) => {
    setUnitSearchQuery(event.target.value);
    const payload:GetListingPayload = {
      page: 1,
      rowsPerPage: unitRowsPerPage,
      searchQuery: event.target.value,
      sortCol,
      sortDir,
    };
    dispatch(getAllUnitSerialNumberStart(payload));
    setUnitPage(1);
  };
  const handleSort = () => {
    if (sortCol === '') {
      setSortCol('UnitSerialNumber');
    } else if (sortDir === 'asc') {
      setSortDir('desc');
    } else {
      setSortDir('asc');
    }
  };

  return (
    <div className="CustomTableContainer CustomTableBorderedContainer">
      <div className="CustomSearchTable">
        <TextField
          className="subHeaderTextfield"
          size="small"
          placeholder="Search..."
          value={unitSearchQuery}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
          variant="outlined"
        />
      </div>
      <div className="oilReportTableContainer">
        <div className="oilReportTableHead">
          <div className="headerTableCell wd-25">
            SN
          </div>
          {/* <div className="headerTableCell wd-45">
            Selected Unit
            {' '}
            <ArrowUpDownIcon />
          </div> */}
          <div className="headerTableCell wd-75" onClick={handleSort}>
            Units
            {' '}
            <ArrowUpDownIcon />
          </div>
        </div>
        {totalUnitSerialNumbers > 0 ? (
          <div className="oilReportTableBody">
            <div className="oilReportTableList">
              <div className="oilReportTableCell wd-25">1</div>
              {/* <div className="oilReportTableCell wd-45">{selectedUnit}</div> */}
              <div className="oilReportTableCell wd-75">
                <div>{allUnitSerialNumbers?.[0]?.UnitSerialNumber}</div>
                <div
                  className="actionBtn"
                  title="Replace with this Unit"
                  onClick={() => handleReplaceUnit(allUnitSerialNumbers?.[0]?.UnitSerialNumber)}
                >
                  <ShuffleIcon />
                </div>
              </div>
            </div>
            {allUnitSerialNumbers?.slice(1)?.map((entry, index) => (
              <div className="oilReportTableList" key={entry.ReportId}>
                <div className="oilReportTableCell wd-25">{index + 2}</div>
                {/* <div className="oilReportTableCell noBorder wd-45">&nbsp;</div> */}
                <div className="oilReportTableCell wd-75">
                  <div>{entry.UnitSerialNumber}</div>
                  <div
                    className="actionBtn"
                    title="Replace with this Unit"
                    onClick={() => handleReplaceUnit(entry.UnitSerialNumber)}
                  >
                    <ShuffleIcon />
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="CustomTableContainer CustomTableBorderedContainer allCentered">
            <div className=""><img src={NoData} alt="No data found" /></div>
          </div>
        )}
      </div>
      <ModalPaginationWithoutPageSize
        rowsPerPage={unitRowsPerPage}
        page={unitPage}
        setRowsPerPage={setUnitRowsPerPage}
        setPage={setUnitPage}
        totalEntries={totalUnitSerialNumbers}
        handleData={handleUnitData}
      />
    </div>
  );
}
